import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogActions, DialogTitle, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StyledDiv } from 'src/styles/styledComponents';

const btnPosition = {
  btnEnd: 'flex-end',
  btnStart: 'flex-start',
  btnCenter: 'center',
  btnBetween: 'space-between',
};

export const StyledBtn = styled(Button)<{ theme: Theme; btn: 'underlinedBtn' | 'filledBtn' | 'emptyBtn' }>(({
  theme,
  btn,
}) => {
  const btnStyle = {
    margin: theme.spacing(0.5),
    underlinedBtn: {
      '& span': {
        color: theme.palette.primary.main,
      },
      textDecoration: 'underline',
      fontWeight: 600,
    },
    filledBtn: {
      '& span': {
        color: theme.palette.background.paper,
      },
      backgroundColor: theme.palette.primary.main,
      padding: theme.spacing(1, 3),
      fontWeight: 600,
    },
    emptyBtn: {
      '& span': {
        color: theme.palette.grey[500],
      },
      fontWeight: 600,
      padding: theme.spacing(1, 3),
      border: `1px solid ${theme.palette.grey[200]}`,
    },
  };

  return btnStyle[btn];
});

export const StyledDialogAction = styled(DialogActions)<{
  btn: 'btnEnd' | 'btnStart' | 'btnCenter' | 'btnBetween';
}>(({ btn, theme }) => ({
  padding: 0,
  marginTop: theme.spacing(2),
  justifyContent: btnPosition[btn],
}));

export const StyledMainWrapper = styled(StyledDiv)<{ theme: Theme }>(({ theme }) => ({
  margin: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    minWidth: 300,
  },
}));

export const StyledIconWrapper = styled(StyledDiv)<{ theme: Theme }>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'row',
  marginTop: theme.spacing(-3),
  marginInlineEnd: theme.spacing(-3),
}));

export const StyledHeaderWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(-3.5),
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '22px',
  fontWeight: 'bold',
}));

export const StyledIconClose = styled(CloseIcon)(({ theme }) => ({
  zIndex: 2,
  color: theme.palette.text.secondary,
  width: theme.spacing(2.5),
}));

export const ModalContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  whiteSpace: 'pre-line',
  direction: 'ltr',
}));

export const ModalHeaderText = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(-3),
  marginBottom: theme.spacing(3),
  color: theme.palette.text.primary,
  fontSize: '16px',
}));
